<template>
    <div class="pb-5">
        <az-toolbar>
            <importar-processo v-if="modoCriacaoParametro === 'IMPORTAR' && ehPerfilSiga" v-az-auth="'Licitacao.Atualizar'" slot="actions"/>
            <az-call-to-action v-if="modoCriacaoParametro === 'MANUAL' || !ehPerfilSiga" active slot="actions" css-class="no-mobile" @click="novo"
                               v-az-auth="'Licitacao.Atualizar'" id="botao-novo">
                <v-icon>add_circle</v-icon>
                Novo
            </az-call-to-action>
            <importar-processo-ipm v-if="orgaoLogado && orgaoLogado.integracaoIPMAtiva" v-az-auth="'Licitacao.Atualizar'" slot="actions"/>

            <az-search id="ajuste-busca"
                       slot="simpleSearch"
                       ref="campoBuscaLicitacao"
                       :filter="filtrosAtivos"
                       @advanced-search="eventoBuscaAvancada"
                       @simple-search="eventoBuscaSimples"
                       @clear="eventoLimpar"
                       @remove-filter="eventoRemoverFiltro"
                       simple-search-placeholder="Informe o objeto, nº do processo, nº do edital ou responsável">

              <az-search-item slot="search-items">
                  <v-text-field v-model="filtrosInterno.objeto.value" label="Objeto"
                                placeholder="Ex. Compra de material de expediente"></v-text-field>
              </az-search-item>

              <az-search-item slot="search-items">
                <az-combo-enum-licitacao v-model="filtrosInterno.modalidade.value"
                                         :enum-object="modalidades"
                                         label="Modalidade" />
              </az-search-item>

              <az-search-item slot="search-items">
                <az-date-simple date-format="DD/MM/YYYY"
                                v-model="filtrosInterno.dataAbertura.value"
                                label="Data de Abertura"
                                name-date="Data de Abertura"
                ></az-date-simple>
              </az-search-item>

              <az-search-item slot="search-items">
                <az-combo-enum-paginado
                    v-model="filtrosInterno.comissao.value"
                    :enum-object="comissoes"
                    :total-pages="totalPagesComissao"
                    @carregarMaisItens="paginarItensComissao"
                    label="Comissao" />
              </az-search-item>

              <az-search-item slot="search-items">
                  <v-text-field v-model="filtrosInterno.edital.value" label="Número do Edital"
                                placeholder="Ex. 001/2020"></v-text-field>
              </az-search-item>
              <az-search-item slot="search-items">
                  <v-text-field v-model="filtrosInterno.processo.value" label="Número do Processo"
                                placeholder="Ex. 000.001/2020"></v-text-field>
              </az-search-item>
              <az-search-item slot="search-items">
                  <v-text-field v-model="filtrosInterno.estado.value" label="Estado"
                                placeholder="Ex. MS, SP, SC"></v-text-field>
              </az-search-item>
              <az-search-item slot="search-items">
                  <v-text-field v-model="filtrosInterno.municipio.value" label="Município"
                                placeholder="Ex. Campo Grande, Presidente Nereu"></v-text-field>
              </az-search-item>
              <az-search-item slot="search-items">
                <az-combo-enum v-model="filtrosInterno.esclarecimentoImpugnacao.value"
                               label="Esclarecimento Impugnação"
                               :enum-object="licitacaoEsclarecimentoImpugnacao">
                </az-combo-enum>
              </az-search-item>
                <az-search-item slot="search-items">
                    <az-combo-enum name="status" v-model="filtrosInterno.status.value" label="Status"
                                   :enum-object="licitacaoStatus"></az-combo-enum>
                </az-search-item>
                <az-search-item slot="search-items" v-if="isFornecedor">
                    <combo-orgao v-model="filtrosInterno.idOrgao.value"></combo-orgao>
                </az-search-item>
            </az-search>
        </az-toolbar>

        <banner-plano-fornecedor v-if="exibirBannerPlano" :plano="planoExpirado" />
        <licitacao-busca-tabela :itens="itens" :paginas="paginas" :total-itens="totalItens"
                                :paginacao="$store.state.licitacaoBusca.paginacao"
                                :modoCriacao="modoCriacaoParametro"
                                @paginar="eventoPaginar"
                                @editar="eventoEditar"
                                @visualizar="eventoVisualizar"
                                @favoritar="eventoFavoritar"
                                @acessarPncp="acessarPncp"
                                @abrirRecursosContrarrazoes="exibirRecursosContrarrazoes"/>
        <az-dialog v-if="mostrarDialogErroMunicipio"
                   @ok="mostrarDialogErroMunicipio = false"
                   :width="450">
            <wrapper-dialog>
                <div class="dialog-erro">
                    <v-card-text class="dialog-title">Existem inconsistências no cadastro do órgão</v-card-text>
                    <span class="dialog-text">Senhor(a) Usuário(a) o município não foi informado no cadastro do seu órgão.</span><br/>
                    <span class="dialog-text">Por favor entre em contato através dos nossos telefones ou do chat disponíveis no portal comprasbr.com.br.</span>
                </div>
            </wrapper-dialog>
        </az-dialog>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {mapActions, mapMutations, mapState} from 'vuex'
    import {actionTypes, mutationTypes} from '@/commons/constants'
    import {statusLicitacao} from '@/commons/constants/index'
    import {filtroOrgao, filtroStatusLicitacao} from '@/commons/filters'
    import {filters} from '@azinformatica/loki'
    import LicitacaoBuscaTabela from './LicitacaoBuscaTabela'
    import ComboOrgao from '@/commons/components/ComboOrgao'
    import WrapperDialog from '@/commons/components/WrapperDialog'
    import BannerPlanoFornecedor from '@/commons/components/BannerPlanoFornecedor'
    import ImportarProcesso from "@/views/licitacao/importar-processo/ImportarProcesso";
    import ImportarProcessoIpm from "@/views/licitacao/importar-processo-ipm/ImportarProcessoIPM";
    import AzDateLicitacao from "@/commons/components/AzDateLicitacao.vue";
    import AzComboEnumLicitacao from "@/commons/components/AzComboEnumLicitacao.vue";
    import AzComboEnumPaginado from "@/commons/components/AzComboEnumPaginado.vue";

    export default {
        components: {
          AzComboEnumPaginado,
          AzComboEnumLicitacao,
          AzDateLicitacao,
          ImportarProcessoIpm,
          ImportarProcesso,
            BannerPlanoFornecedor, LicitacaoBuscaTabela, ComboOrgao, WrapperDialog
        },
        data() {
            return {
                licitacaoStatus: statusLicitacao,
                licitacaoEsclarecimentoImpugnacao: {
                  true: 'Sim',
                  false: 'Não'
                },
                filtrosInterno: _.cloneDeep(this.$store.state.licitacaoBusca.filtros),
                itens: [],
                paginas: 0,
                totalItens: 0,
                mostrarDialogErroMunicipio: false,
                exibirBannerPlano: false,
                planoExpirado: null,
                orgaoLogado: null,
                comissoes: {},
                modalidades: {},
                paginacaoInternaComissao: _.cloneDeep(this.$store.state.comissaoBusca.paginacao),
                totalPagesComissao: 0,
            }
        },
        computed: {
            ...mapState(['parametros']),
            modoCriacaoParametro(){
              return this.parametros.propriedadesLicitacao.modoCriacaoProcesso
            },
            ehPerfilSiga(){
              return !this.parametros.propriedadesLicitacao.ehPerfilComprasBR
            },
            filtrosAtivos() {
                const filtros = _.cloneDeep(this.$store.state.licitacaoBusca.filtros)
                const filtrosAtivos = {}
                for (let [chave, val] of Object.entries(filtros)) {
                    if (filtros[chave].value) {
                        if (chave === 'status') {
                            val.value = filtroStatusLicitacao(val.value)
                        }
                        if (chave === 'idOrgao') {
                            val.value = filtroOrgao(val.value)
                        }
                        val.valueTruncated = filters.azClipText(val.value, 10)
                        filtrosAtivos[chave] = val
                    }
                }
                return filtrosAtivos
            },
        },
        async mounted() {
            this.verificarEventoMensagemLicitacao()
            await this.buscarAssinaturas()
            this.forcarExibirFiltrosAvancados()
            await this.buscarOrgaoLogado()
            await this.acaoBuscarComissoes()
            await this.acaoBuscarModalidades()
        },
        methods: {
            ...mapMutations([
                mutationTypes.LIMPAR_FILTROS_BUSCA_LICITACAO,
                mutationTypes.SET_FILTROS_BUSCA_LICITACAO,
                mutationTypes.SET_PAGINACAO_BUSCA_LICITACAO
            ]),
            ...mapActions([
                actionTypes.BUSCAR_LICITACOES,
                actionTypes.DESFAVORITAR_LICITACAO,
                actionTypes.FAVORITAR_LICITACAO,
                actionTypes.BUSCAR_DADOS_ASSINATURAS_FORNECEDOR,
                actionTypes.BUSCAR_MODALIDADES,
                actionTypes.BUSCAR_COMISSOES_APURACAO_PAGINADO
            ]),
            async buscarOrgaoLogado() {
              if(this.$store.state.loki.user.type === 'EXTERNO'){return}
              const uo = await this.$store.dispatch(actionTypes.BUSCAR_ORGAO, {orgaoId:this.$store.state.loki.user.domainId});
              if(!uo) {return}
              const orgaos = this.$store.state.orgaos
              this.orgaoLogado = orgaos.find(orgao => orgao.id === uo.unidadeOrganizacional.id)
            },
            verificarEventoMensagemLicitacao(){
                if(this.$route.name === 'licitacaoBuscaMsg'){
                    if(this.$route.params.tipo === 'licitacaoexcluida'){
                      this.mostrarNotificacaoErro("A licitação teve a sua publicação cancelada, por isso você foi direcionado para a tela de listagem.")
                      this.$router.push({name: 'licitacaoBusca'})
                    }
                }
            },
            async buscarAssinaturas() {
                if (this.$store.state.loki.user.type === 'EXTERNO' && this.$store.state.parametros.propriedadesLicitacao.exibirBanner) {
                    const resultado = await this.buscarDadosAssinaturasFornecedor()
                    if (resultado.quantidadeAssinaturas === 0) {
                        this.exibirBannerPlano = true
                    }else if(!resultado.assinaturaAtual && !resultado.assinaturaPendente && resultado.ultimaAssinaturaExpirada){
                        this.exibirBannerPlano = true
                        this.planoExpirado = resultado.ultimaAssinaturaExpirada.planoProduto.nome
                    }
                }
            },
            async acaoBuscarComissoes() {

              const resultado = await this.buscarComissoesApuracaoPaginado()
              if(resultado){
                this.comissoes = resultado.items.reduce((acc, item) => {
                  acc[item.descricao] = item.sigla
                  return acc
                }, {})
                this.totalPagesComissao = resultado.totalPages
              }
            },
            async acaoBuscarModalidades() {
              const response = await this.buscarModalidades()

              if (response != null && response.modalidades) {
                this.modalidades = response.modalidades.reduce((acc, item) => {
                  acc[item] = item
                  return acc
                }, {})
              }
            },
            async buscar() {
                try {
                    this.$store.commit(mutationTypes.SET_FILTROS_BUSCA_LICITACAO, _.cloneDeep(this.filtrosInterno))
                    this.setMensagemLoading('Carregando Licitações...')
                    const resultado = await this.buscarLicitacoes()
                    this.itens = resultado.items
                    this.paginas = resultado.totalPages
                    this.totalItens = resultado.totalElements
                } catch (err) {
                    const municipioException = 'br.com.azi.licitacao.licitacao.licitacao.exception.LicitacaoOrgaoSemMunicipioException'
                    if (err.response && err.response.data.exception === municipioException) {
                        this.mostrarDialogErroMunicipio = true
                    }
                }
            },
            async desfavoritar(id) {
                this.setMensagemLoading('Desfavoritando a Licitação...')
                await this.desfavoritarLicitacao(id)
            },
            eventoBuscaAvancada() {
                this.buscar()
            },
            eventoBuscaSimples(valor) {
                this.filtrosInterno.conteudo.value = valor
                this.buscar()
            },
            eventoEditar(id) {
              const item = this.itens.find(item => item.id === id);
              let isItemEmElaboracao = !item.publicado

              if (item && item.modalidade === 'CREDENCIAMENTO') {
                let objetoDaRota = {
                  name: isItemEmElaboracao ? 'credenciamento' : 'CredenciamentoAtualizacaoSelecaoParticipantes',
                  params: {id: item.id},
                  query: {edicao: true}
                }

                this.$router.push(objetoDaRota)
              } else {
                this.$router.push({name: 'licitacao', params: {id}, query: {edicao: true}})
              }
            },
            async eventoFavoritar(licitacao) {
                if (licitacao.favorito) {
                    await this.desfavoritar(licitacao.id)
                } else {
                    await this.favoritar(licitacao.id)
                }
                await this.buscar()
            },
            async eventoLimpar() {
                this.$store.commit(mutationTypes.LIMPAR_FILTROS_BUSCA_LICITACAO)
                this.$store.commit(mutationTypes.SET_PAGINACAO_BUSCA_LICITACAO, {
                    page: 1,
                    rowsPerPage: 10,
                    sortBy: null,
                    descending: false
                })
                this.filtrosInterno = _.cloneDeep(this.$store.state.licitacaoBusca.filtros)
                if (this.$refs.campoBuscaLicitacao) {
                    this.$refs.campoBuscaLicitacao.searchText = null
                }
                await this.buscar()
            },
            eventoPaginar(paginacao) {
                this.$store.commit(mutationTypes.SET_PAGINACAO_BUSCA_LICITACAO, paginacao)
                this.buscar()
            },
            eventoRemoverFiltro(propriedade) {
                if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                    this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
                }
                this.buscar()
            },
            eventoVisualizar(id) {
              const item = this.itens.find(item => item.id === id);
              if (this.isFornecedor) {
                this.eventoVisualizarFornecedor(item)
              } else {
                this.eventoVisualizarServidorPublico(item)
              }
            },
            eventoVisualizarFornecedor(item) {
              if (item && item.modalidade === 'CREDENCIAMENTO') {
                this.$router.push({name: 'credenciamentoFornecedor', params: {id: item.id}})
              } else {
                this.$router.push({name: 'licitacaoFornecedor', params: {id: item.id}})
              }
            },
            eventoVisualizarServidorPublico(item) {
              if (item && item.modalidade === 'CREDENCIAMENTO') {
                this.$router.push({name: 'credenciamento', params: {id: item.id}})
              } else {
                this.$router.push({name: 'licitacao', params: {id: item.id}})
            }
            },
            async favoritar(id) {
                this.setMensagemLoading('Favoritando a Licitação...')
                await this.favoritarLicitacao(id)
            },
            async acessarPncp({cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica}) {
              await this.$store.dispatch(actionTypes.EXIBIR_NO_PNCP, {cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica})
            },
            exibirRecursosContrarrazoes(licitacaoId){
              this.$router.push({path: `/licitacoes/${licitacaoId}/atualizacaoRecursoContrarrazao?edicao=true`})
            },
            novo() {
                this.$router.push({name: 'licitacaoNovo'})
            },
            forcarExibirFiltrosAvancados(){
              const componenteBusca = this.$refs.campoBuscaLicitacao
              componenteBusca.hasAdvancedSearchItems = true
            },
            async paginarItensComissao(){
                this.paginacaoInternaComissao.rowsPerPage = this.paginacaoInternaComissao.rowsPerPage + 10
                this.$store.commit(mutationTypes.SET_PAGINACAO_BUSCA_COMISSAO, this.paginacaoInternaComissao)
                await this.acaoBuscarComissoes()
            }
        }
    }
</script>

<style lang="stylus">
#ajuste-busca > .simple-search > .input-search
  width: 410px !important;
  overflow hidden
</style>